import interviewRequestDetailsReducer from './interviewRequestDetails'
import interviewRequestListReducer from './interviewRequestList'

export default {
  interviewRequestDetails: interviewRequestDetailsReducer,
  interviewRequestList: interviewRequestListReducer,
}

import * as interviewRequestDetailsView from './interviewRequestDetails'
import * as interviewRequestListView from './interviewRequestList'

export { interviewRequestDetailsView, interviewRequestListView }
